const isEmailAddressInWhitelistedDomains = (emailAddress, whitelistedDomains) => {
    if (!(emailAddress && typeof emailAddress === 'string')) {
        throw new Error('Invalid Argument: `emailAddress` is required.')
    }
    if (!Array.isArray(whitelistedDomains)) {
        throw new Error('Invalid Argument: `whitelistedDomains` must be an Array.')
    }
    return whitelistedDomains.some((domain) => emailAddress.toLowerCase().endsWith(domain.toLowerCase()))
}

export { isEmailAddressInWhitelistedDomains }
